module.exports = __webpack_public_path__ + "static/media/logo.1982f4ea.png";